import {enqueueSnackbar} from 'notistack';

import {
  API_BASE_URL,
  SUCCESS_CHANGE,
  STRUCTURE_GROUP_EXITS,
  ERROR,
  STRUCTURE_GROUP_FAVORITE_SUCCESS,
  STRUCTURE_GROUP_UNFAVORITE_SUCCESS,
} from '../../constants';
import {
  StructureContextEntries,
  StructureFavoriteRequestDto,
  StructureResponseItemDto,
} from '../../models';
import {get, post, del} from '../api';

export function getStructure(token: string) {
  return get(`${API_BASE_URL}/structure`, {
    headers: {Authorization: `Bearer ${token}`},
    responseType: 'json',
  });
}

export function editStructure(
  token: string,
  action: StructureContextEntries,
  data: {},
  running: (value: boolean) => void,
  onClose: () => void,
) {
  let url = 'structure/';
  switch (action) {
    case StructureContextEntries.CREATE:
      url = 'structure/create';
      break;
    case StructureContextEntries.DELETE:
      url = 'structure/delete';
      break;
    case StructureContextEntries.EDIT:
      url = 'structure/edit';
      break;
  }

  post(`${API_BASE_URL}/${url}`, {
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(SUCCESS_CHANGE, {variant: 'success'});
      onClose();
    })
    .catch(err => {
      switch (err?.response?.status) {
        case 406:
          enqueueSnackbar(STRUCTURE_GROUP_EXITS, {variant: 'warning'});
          break;
        default:
          enqueueSnackbar(ERROR, {variant: 'error'});
      }
    })
    .finally(() => {
      running(false);
    });
}

export function favoriteStructureItem(
  token: string,
  item: StructureResponseItemDto,
  onRequestComplete: () => void,
) {
  const data: StructureFavoriteRequestDto = {
    structureId: item.id,
  };

  post(`${API_BASE_URL}/structure/favorite`, {
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(STRUCTURE_GROUP_FAVORITE_SUCCESS, {variant: 'success'});
      onRequestComplete();
    })
    .catch(_err => {
      enqueueSnackbar(ERROR, {variant: 'error'});
    });
}

export function unfavoriteStructureItem(
  token: string,
  item: StructureResponseItemDto,
  onRequestComplete: () => void,
) {
  const data: StructureFavoriteRequestDto = {
    structureId: item.id,
  };

  del(`${API_BASE_URL}/structure/favorite`, {
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(STRUCTURE_GROUP_UNFAVORITE_SUCCESS, {
        variant: 'success',
      });
      onRequestComplete();
    })
    .catch(_err => {
      enqueueSnackbar(ERROR, {variant: 'error'});
    });
}
